import { render, staticRenderFns } from "./AdminList.vue?vue&type=template&id=3b5ac62b&scoped=true"
import script from "./AdminList.vue?vue&type=script&lang=js"
export * from "./AdminList.vue?vue&type=script&lang=js"
import style0 from "./AdminList.vue?vue&type=style&index=0&id=3b5ac62b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5ac62b",
  null
  
)

export default component.exports